var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-sms-button",class:{ 
    'has-unread': _vm.unreadCount > 0, 
    'pulsing': _vm.hasNewMessage,
    'new-sms': !_vm.hasExistingConversation,
    'loading': _vm.isLoading,
    'feature-disabled': !_vm.canSendSms
  },attrs:{"title":_vm.isLoading ? 'Loading...' : _vm.buttonTooltip},on:{"click":function($event){!_vm.isLoading && _vm.$emit('click')}}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_c('i',{staticClass:"fa",class:_vm.buttonIcon}),(_vm.unreadCount > 0 && !_vm.isLoading)?_c('span',{staticClass:"unread-badge"},[_vm._v(_vm._s(_vm.unreadCount))]):_vm._e(),_c('div',{staticClass:"tooltip-text"},[_vm._v("\n    "+_vm._s(_vm.tooltipText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }